import { makeStyles } from "@material-ui/core/styles";

export const dialogStyles = makeStyles({
  paper: {
    boxSizing: "border-box",
    minWidth: "min(calc(100vw - 20px), 750px)"
  }
});
